import styled from "styled-components";
import dynamic from 'next/dynamic';

const HeaderMock = styled.div`
    width: 100%;
    height: 80px;
`

const HeaderDS = dynamic(() =>
  import("@olxbr/olx-components").then(mod => mod.Header),
  { ssr: false, loading: () => <HeaderMock /> },
);

// TODO: Priorizar migração do design system para eliminar esse tipo de ajuste
const Wrapper = styled.div`
    .olx-header .olx-modal__dialog--side-sheet {
        left: auto;
        right: 0;
        transform: translateX(100%);
    }

    .olx-header .olx-modal__dialog--side-sheet[data-show=true] {
        transform: translateX(0);
    }
`

export const Header = () => 
    <Wrapper>
        <HeaderDS />
    </Wrapper>